<template>
  <router-view :selectForm="selectForm" />
</template>

<script>
export default {
  data() {
    return {
      selectForm: this.genSelectForm(),
      selectNameType: 0, // 切换检索类别
      timeList: '', // 右上角时间筛选
      createTime: '', // 订单创建时间
      scheduleCreateTime: '', // 计划单创建时间
      accountType: '0',
      partnerId: '',
      routerParams: {
        orderName: '',
        scheduleName: '',
        orderId: '',
        scheduleId: ''
      },
      searchParam: undefined
    }
  },
  provide() {
    return {
      projectOrder: this
    }
  },
  watch: {
    selectNameType() {
      this.searchParam = ''
    }
  },
  methods: {
    genSelectForm() {
      return {
        orderStatus: '',
        orderPartnerName: '', // 订单广告主
        contractTime: '', // 订单投放时间
        buyType: '', // 购买方式
        schedulePartnerName: '', // 计划单广告主
        scheduleStatus: '',
        putTime: '', // 计划单投放时间
        saleType: '', // 销售方式
        payment: '', // 结算方式
        scheduleSource: '', // 程序化来源
        supportMode: '', // 程序化类型
        scheduleSpaceId: '', // 计划单广告位
        checkStatus: '',
        mediaClassId: '', // 创意类型
        spaceId: '',
        mediaPartnerId: '', // 创意广告主
        mateCheckCode: '',
        mediaPartnerName: '', // 广告主
        materialLibraryStatus: '', // 素材库状态
        materialLibraryType: '', // 素材
        duration: '', // 素材时长
        materialLibrarySpaceId: '',
        materialLibraryPartnerName: '',
        cableCheckStatus: '', // 媒体方
        auditStatus: '' // 牌照方审核状态 目前只有南传
      }
    }
  },
  created() {
    this.accountType = this.$service.state.user.accountType
    // accountType =0，广告主
    if (this.accountType === '0') {
      this.partnerId = this.$service.state.user.partnerId
    }
  }
}
</script>

<style>
</style>
